// extracted by mini-css-extract-plugin
export default {"section":"AboutUsSection_section__j8j+q","top":"AboutUsSection_top__Vw2Eg","adventages":"AboutUsSection_adventages__N3WC1","titleCenter":"AboutUsSection_titleCenter__xJYFE"};